// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash-spreadsheet .Select,
.dash-spreadsheet .Select-control {
    border: none;
    cursor: pointer;
    height: 30px;  /* matches the td height and line-height */
    border: none;
}

.dash-spreadsheet .Select-placeholder,
.dash-spreadsheet .Select--single > .Select-control .Select-value {
    height: 100%;
    line-height: inherit;
}

.dash-spreadsheet .Select.has-value.Select--single > .Select-control .Select-value .Select-value-label,
.dash-spreadsheet .Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {
    color: var(--text-color);
}

.dash-spreadsheet .Select:hover,
.dash-spreadsheet .Select-control:hover {
    border: none;
    box-shadow: none;
    cursor: pointer;
}

.dash-spreadsheet .Select-menu-outer {
    z-index: 100;
}

.dash-spreadsheet .Select-arrow {
    border-top-color: var(--faded-dropdown);
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
}

.dash-spreadsheet .Select-control:hover .Select-arrow {
    border-top-color: var(--accent);
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
}

.dash-spreadsheet .is-open > .Select-control .Select-arrow {
    border-bottom-color: var(--background-color-8-react-select);
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
}

.dash-spreadsheet .Select--multi .Select-value,
.dash-spreadsheet .Select--multi a.Select-value-label {
    color: var(--color-8-react-select);
}

.dash-spreadsheet .Select {
    border-radius: 0;
}

.dash-spreadsheet .Select.is-disabled > .Select-control {
    border: none;
}

.dash-spreadsheet .Select--multi .Select-value-icon:hover,
.dash-spreadsheet .Select--multi .Select-value-icon:focus {
    font-weight: bold;
}

.dash-spreadsheet .Select.is-disabled .Select-control {
    cursor: not-allowed;
}

.dash-spreadsheet .Select-menu-outer {
    background-color: white;
    border: none;
    border-bottom: thin var(--border) solid;
    border-radius: 0;
    border-top: none;
}

.dash-spreadsheet .Select-option {
    background-color: inherit;
    color: var(--accent);
}

.dash-spreadsheet .Select-option:hover {
    font-weight: bold;
    color: var(--accent);
    background-color: var(--hover);
}

.dash-spreadsheet .Select.is-focused:not(.is-open) > .Select-control {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background: #fff;
}

.dash-spreadsheet .Select-option.is-focused {
    background-color: white;
    color: var(--accent);
    font-weight: bold;
}

.dash-spreadsheet .Select-clear {
    color: transparent;
}
.dash-spreadsheet .Select:hover .Select-clear {
    color: var(--accent);
}

.dash-spreadsheet .Select-control {
    padding-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/dash-table/components/Table/Dropdown.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,eAAe;IACf,YAAY,GAAG,0CAA0C;IACzD,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,2DAA2D;IAC3D,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".dash-spreadsheet .Select,\n.dash-spreadsheet .Select-control {\n    border: none;\n    cursor: pointer;\n    height: 30px;  /* matches the td height and line-height */\n    border: none;\n}\n\n.dash-spreadsheet .Select-placeholder,\n.dash-spreadsheet .Select--single > .Select-control .Select-value {\n    height: 100%;\n    line-height: inherit;\n}\n\n.dash-spreadsheet .Select.has-value.Select--single > .Select-control .Select-value .Select-value-label,\n.dash-spreadsheet .Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n    color: var(--text-color);\n}\n\n.dash-spreadsheet .Select:hover,\n.dash-spreadsheet .Select-control:hover {\n    border: none;\n    box-shadow: none;\n    cursor: pointer;\n}\n\n.dash-spreadsheet .Select-menu-outer {\n    z-index: 100;\n}\n\n.dash-spreadsheet .Select-arrow {\n    border-top-color: var(--faded-dropdown);\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n}\n\n.dash-spreadsheet .Select-control:hover .Select-arrow {\n    border-top-color: var(--accent);\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n}\n\n.dash-spreadsheet .is-open > .Select-control .Select-arrow {\n    border-bottom-color: var(--background-color-8-react-select);\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: transparent;\n}\n\n.dash-spreadsheet .Select--multi .Select-value,\n.dash-spreadsheet .Select--multi a.Select-value-label {\n    color: var(--color-8-react-select);\n}\n\n.dash-spreadsheet .Select {\n    border-radius: 0;\n}\n\n.dash-spreadsheet .Select.is-disabled > .Select-control {\n    border: none;\n}\n\n.dash-spreadsheet .Select--multi .Select-value-icon:hover,\n.dash-spreadsheet .Select--multi .Select-value-icon:focus {\n    font-weight: bold;\n}\n\n.dash-spreadsheet .Select.is-disabled .Select-control {\n    cursor: not-allowed;\n}\n\n.dash-spreadsheet .Select-menu-outer {\n    background-color: white;\n    border: none;\n    border-bottom: thin var(--border) solid;\n    border-radius: 0;\n    border-top: none;\n}\n\n.dash-spreadsheet .Select-option {\n    background-color: inherit;\n    color: var(--accent);\n}\n\n.dash-spreadsheet .Select-option:hover {\n    font-weight: bold;\n    color: var(--accent);\n    background-color: var(--hover);\n}\n\n.dash-spreadsheet .Select.is-focused:not(.is-open) > .Select-control {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    background: #fff;\n}\n\n.dash-spreadsheet .Select-option.is-focused {\n    background-color: white;\n    color: var(--accent);\n    font-weight: bold;\n}\n\n.dash-spreadsheet .Select-clear {\n    color: transparent;\n}\n.dash-spreadsheet .Select:hover .Select-clear {\n    color: var(--accent);\n}\n\n.dash-spreadsheet .Select-control {\n    padding-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
